const HandleClick = (event) => {
    if(event.target.getAttribute("name") == "download-photos"){
        DownloadPopup('download-pop');
    }else if(event.target.getAttribute("name") == "download-template"){
        DownloadPopup('download-pop-template');
    }else if(event.target.getAttribute("name") == "print"){
        PrintOrder();
    }
}

const PrintOrder = () => {
    window.print();
};

const DownloadPopup = (id) => {
    let popup = document.querySelector(`#${id}`)
    popup.classList.toggle('hidden')
}

function DownloadImage(filename, imageUrl) {
    fetch(`https://${imageUrl}`)
    .then(response => response.blob())
    .then(blob => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(url);
    });
}
